/**
 * Container Type Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {string}
 */
window.containerTypeFormatter = function(value, row) {
    const TYPE_REEFER = window.TYPE_REEFER;
    const TYPE_DRY_CONTAINER = window.TYPE_DRY_CONTAINER;
    let html = '';
    switch (row.container_type) {
        case TYPE_REEFER:
            html += __('Reefer');
            break;
        case TYPE_DRY_CONTAINER:
            html += __('Dry Container');
            break;
    }
    return html;
};
